package com.martdev.flickq.movie.model

data class Genre(
    val id: Long = 0,
    val name: String = ""
)
